$(() => {
  window.Geenie.ComingSoonNotification = {
    create(projectId) {
      return $.ajax({
        type: 'POST',
        url: '/api/comingsoonnotification/register',
        cache: false,
        dataType: 'json',
        data: {
          project_id: projectId,
          fuel_csrf_token: fuel_csrf_token(),
        },
      });
    },
    getIsRegistered(projectId) {
      return $.ajax({
        type: 'GET',
        url: '/api/comingsoonnotification/is_registered',
        data: { projectId: projectId },
        cache: false,
        dataType: 'json',
      });
    },
  };
});
